import { render, staticRenderFns } from "./die-options-summary.component.vue?vue&type=template&id=ee323d7a&"
import script from "./die-options-summary.component.ts?vue&type=script&lang=ts&"
export * from "./die-options-summary.component.ts?vue&type=script&lang=ts&"
import style0 from "./die-options-summary.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
